/*eslint-env node */

const backbone = require( 'backbone' );

require('backbone.radio');

module.exports = backbone;